import {
  i as i2
} from "./chunk.LP7FQRAP.js";
import {
  carousel_styles_default
} from "./chunk.HUIFS3FI.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  e2,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/carousel/carousel.ts
import { t as t2 } from "i18next";
var FadvCarousel = class extends s {
  constructor() {
    super(...arguments);
    this.activeSlide = 0;
    this.autoscrollInterval = 10;
    this.indicatorsPosition = "contained";
  }
  get slides() {
    return [...this.querySelectorAll("fadv-carousel-slide")];
  }
  connectedCallback() {
    super.connectedCallback();
    this.resizeObserver = new ResizeObserver(() => this.resizeSlidesContainer());
    this.resizeObserver.observe(document.body);
    this.handleVisibilityChange = this.handleSlotChange.bind(this);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }
  disconnectedCallback() {
    this.resizeObserver.unobserve(document.body);
    this.resizeObserver.disconnect();
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    super.disconnectedCallback();
  }
  firstUpdated() {
    this.enableAutoscroll();
  }
  enableAutoscroll() {
    this.disableAutoscroll();
    if (this.autoscroll) {
      this.autoscrollTimeoutHandle = setTimeout(() => {
        this.nextSlide();
      }, this.autoscrollInterval * 1e3);
    }
  }
  disableAutoscroll() {
    if (this.autoscrollTimeoutHandle) {
      clearInterval(this.autoscrollTimeoutHandle);
    }
  }
  async handleActiveSlideChange(oldSlide, newSlide) {
    const slides = this.slides;
    if (!oldSlide && oldSlide !== 0) {
      const slide = slides[newSlide];
      slides.forEach((s2) => s2.active = false);
      slide.active = true;
      return;
    }
    this.disableAutoscroll();
    const current = slides[oldSlide];
    const next = slides[newSlide];
    next.active = true;
    await stopAnimations(this);
    let hide;
    let show;
    if (oldSlide + 1 === newSlide || oldSlide === this.slideCount - 1 && newSlide === 0) {
      hide = getAnimation(this, "carousel.next-hide");
      show = getAnimation(this, "carousel.next-show");
    } else {
      hide = getAnimation(this, "carousel.prev-hide");
      show = getAnimation(this, "carousel.prev-show");
    }
    animateTo(current, hide.keyframes, hide.options);
    await animateTo(next, show.keyframes, show.options);
    current.active = false;
    this.liveRegion.textContent = t2("components:carousel.announcement", { index: newSlide + 1, count: this.slideCount });
    emit(this, "carousel-slide-change", { detail: { slideIndex: newSlide } });
    this.enableAutoscroll();
  }
  handleDotActivate(event) {
    const target = event.target;
    this.activeSlide = parseInt(target.value || "0", 10);
    this.focusCurrentSlide();
  }
  handleSlotChange() {
    this.slideCount = this.slides.length;
    this.resizeSlidesContainer();
  }
  resizeSlidesContainer() {
    var _a;
    this.slideHeight = (_a = this.height) != null ? _a : Math.max(...this.slides.map((s2) => {
      var _a2;
      const element = (_a2 = s2.slide) != null ? _a2 : s2;
      return element.getBoundingClientRect().height;
    }));
  }
  handleVisibilityChange() {
    switch (document.visibilityState) {
      case "hidden":
        this.disableAutoscroll();
        break;
      case "visible":
        this.enableAutoscroll();
        break;
    }
  }
  handleSwipeStart(event) {
    if (this.disableSwipe)
      return;
    this.isSwiping = true;
    if (event.type.includes("touch")) {
      this.swipeStart = event.touches[0].pageX;
    } else {
      this.swipeStart = event.x;
    }
  }
  handleSwipeEnd() {
    this.isSwiping = false;
    this.swipeStart = void 0;
  }
  handleSwipe(event) {
    if (!this.isSwiping)
      return;
    if (!this.swipeStart)
      return;
    let end;
    if (event.type.includes("touch")) {
      end = event.touches[0].pageX;
    } else {
      end = event.x;
    }
    if (Math.abs(this.swipeStart - end) < 10)
      return;
    if (this.swipeStart > end) {
      this.nextSlide();
    } else {
      this.previousSlide();
    }
    this.isSwiping = false;
    this.swipeStart = void 0;
  }
  handleResume() {
    if (!this.autoscroll)
      return;
    if (!this.autoscrollPaused)
      return;
    this.autoscrollPaused = false;
    this.enableAutoscroll();
  }
  handlePause() {
    if (!this.autoscroll)
      return;
    if (this.autoscrollPaused)
      return;
    this.autoscrollPaused = true;
    this.disableAutoscroll();
  }
  handleMouseenter() {
    this.disableAutoscroll();
  }
  handleMouseleave() {
    if (!this.autoscrollPaused) {
      this.enableAutoscroll();
    }
  }
  handleFocusIn(event) {
    if (!this.autoscroll)
      return;
    if (!hasTag(event.target, "fadv-carousel-slide")) {
      this.disableAutoscroll();
    }
  }
  handleFocusOut(event) {
    if (!this.autoscroll)
      return;
    if (!hasTag(event.target, "fadv-carousel-slide") && !this.autoscrollPaused) {
      this.enableAutoscroll();
    }
  }
  focusCurrentSlide() {
    setTimeout(() => {
      const rect = this.getBoundingClientRect();
      if (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
        const slide = this.slides[this.activeSlide];
        slide == null ? void 0 : slide.focus();
      }
    }, carouselDuration);
  }
  nextSlide() {
    this.gotoSlide(this.activeSlide + 1);
  }
  previousSlide() {
    this.gotoSlide(this.activeSlide - 1);
  }
  gotoSlide(index) {
    if (index > this.slideCount - 1) {
      index = 0;
    } else if (index < 0) {
      index = this.slideCount - 1;
    }
    this.activeSlide = index;
    this.focusCurrentSlide();
  }
  renderDots() {
    return $`${Array.from({ length: this.slideCount }).map((_, i3) => {
      const isActive = this.activeSlide === i3;
      let label;
      if (isActive) {
        label = t2("components:carousel.currentIndicator", { index: i3 + 1 });
      } else {
        label = t2("components:carousel.indicator", { index: i3 + 1 });
      }
      return $`<fadv-progress-dot label=${label} .active=${l2(isActive)} value=${i3} @click=${this.handleDotActivate}></fadv-progress-dot>`;
    })} `;
  }
  renderAutoscrollControls() {
    if (!this.autoscroll)
      return w;
    return $`<div class="carousel__autoscroll"><div class="carousel__autoscroll-controls"><button aria-label=${t2("components:carousel.pause")} aria-disabled=${l(this.autoscrollPaused ? "true" : void 0)} .disabled=${l2(this.autoscrollPaused)} @click=${this.handlePause} ><fadv-icon aria-hidden="true" library="solid" name="pause"></fadv-icon></button><button aria-label=${t2("components:carousel.resume")} aria-disabled=${l(!this.autoscrollPaused ? "true" : void 0)} .disabled=${l2(!this.autoscrollPaused)} @click=${this.handleResume} ><fadv-icon aria-hidden="true" library="solid" name="play"></fadv-icon></button></div></div>`;
  }
  render() {
    return $`<div class=${o({
      carousel: true,
      "carousel--hide-controls": this.hideControls,
      "carousel--hide-indicators": this.hideIndicators,
      "carousel--indicator-below": this.indicatorsPosition !== "contained",
      "carousel--indicator-contained": this.indicatorsPosition === "contained"
    })} ><fadv-visually-hidden class="carousel__live-region" aria-live="polite" aria-atomic="true"></fadv-visually-hidden><div class="carousel__container"><div class="carousel__slides" style=${i2({
      height: this.slideHeight ? `${this.slideHeight}px` : void 0
    })} @mousedown=${this.handleSwipeStart} @mousemove=${this.handleSwipe} @mouseup=${this.handleSwipeEnd} @touchstart=${this.handleSwipeStart} @touchmove=${this.handleSwipe} @touchend=${this.handleSwipeEnd} @focusin=${this.handleFocusIn} @focusout=${this.handleFocusOut} @mouseenter=${this.handleMouseenter} @mouseleave=${this.handleMouseleave} ><slot @slotchange=${this.handleSlotChange}></slot></div>${this.renderAutoscrollControls()}<div class="carousel__control carousel__control-prev"><button aria-label=${t2("components:carousel.previousSlide")} @click=${this.previousSlide}><fadv-icon size="large" library="solid" name="chevron-left"></fadv-icon></button></div><div class="carousel__control carousel__control-next"><button aria-label=${t2("components:carousel.nextSlide")} @click=${this.nextSlide}><fadv-icon size="large" library="solid" name="chevron-right"></fadv-icon></button></div></div><div class="carousel__indicators"><fadv-progress-dots label=${t2("components:carousel.indicators")}>${this.renderDots()}</fadv-progress-dots></div></div>`;
  }
};
FadvCarousel.styles = carousel_styles_default;
__decorateClass([
  t()
], FadvCarousel.prototype, "slideCount", 2);
__decorateClass([
  t()
], FadvCarousel.prototype, "swipeStart", 2);
__decorateClass([
  t()
], FadvCarousel.prototype, "isSwiping", 2);
__decorateClass([
  t()
], FadvCarousel.prototype, "autoscrollPaused", 2);
__decorateClass([
  t()
], FadvCarousel.prototype, "slideHeight", 2);
__decorateClass([
  e()
], FadvCarousel.prototype, "activeSlide", 2);
__decorateClass([
  e({ type: Boolean })
], FadvCarousel.prototype, "autoscroll", 2);
__decorateClass([
  e({ type: Number })
], FadvCarousel.prototype, "autoscrollInterval", 2);
__decorateClass([
  e({ attribute: "indicators-position" })
], FadvCarousel.prototype, "indicatorsPosition", 2);
__decorateClass([
  e({ type: Boolean, attribute: "hide-indicators" })
], FadvCarousel.prototype, "hideIndicators", 2);
__decorateClass([
  e({ type: Boolean, attribute: "hide-controls" })
], FadvCarousel.prototype, "hideControls", 2);
__decorateClass([
  e({ type: Boolean, attribute: "disable-swipe" })
], FadvCarousel.prototype, "disableSwipe", 2);
__decorateClass([
  e()
], FadvCarousel.prototype, "height", 2);
__decorateClass([
  i(".carousel__live-region")
], FadvCarousel.prototype, "liveRegion", 2);
__decorateClass([
  watch("autoscroll", { waitUntilFirstUpdate: true })
], FadvCarousel.prototype, "enableAutoscroll", 1);
__decorateClass([
  watch("activeSlide")
], FadvCarousel.prototype, "handleActiveSlideChange", 1);
__decorateClass([
  e2({ passive: true })
], FadvCarousel.prototype, "handleSwipeStart", 1);
__decorateClass([
  e2({ passive: true })
], FadvCarousel.prototype, "handleSwipeEnd", 1);
__decorateClass([
  e2({ passive: true })
], FadvCarousel.prototype, "handleSwipe", 1);
FadvCarousel = __decorateClass([
  n("fadv-carousel")
], FadvCarousel);
var carouselDuration = 350;
setDefaultAnimation("carousel.next-show", {
  keyframes: [{ left: "100%" }, { left: "0" }],
  options: { duration: carouselDuration, easing: "ease" }
});
setDefaultAnimation("carousel.next-hide", {
  keyframes: [{ left: "0" }, { left: "-100%" }],
  options: { duration: carouselDuration, easing: "ease" }
});
setDefaultAnimation("carousel.prev-show", {
  keyframes: [{ left: "-100%" }, { left: "0" }],
  options: { duration: carouselDuration, easing: "ease" }
});
setDefaultAnimation("carousel.prev-hide", {
  keyframes: [{ left: 0 }, { left: "100%" }],
  options: { duration: carouselDuration, easing: "ease" }
});

export {
  FadvCarousel
};
